import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import { SessionDTOExtended, Vehicle } from "types";
import { ModalEnum } from "myParkdUtils/enums";
import * as modalWindowActions from 'root/modal/modalWindowActions';


export const EditableTableField = (props: Props) => {

    const { modalName, rowData, defaultValue, placeholder, openModal } = props;

    const onMouseDown = (e: React.MouseEvent<HTMLInputElement>) => {
        e.preventDefault();
        (e.target as HTMLInputElement).blur();
    }

    return (
        <div className="rel session-note-input-wrapper">
            <input type="text" className="text-field"
                defaultValue={defaultValue ?? ''}
                placeholder={placeholder ?? ''}
                onMouseDown={(e) => onMouseDown(e)}
                onClick={() => openModal(modalName, rowData)}
            />
            <FontAwesomeIcon className="edit-note-icon" icon={faEdit} style={{ pointerEvents: 'none' }} />
        </div>
    )
}


type OwnProps = {
    defaultValue: string,
    placeholder: string,
    modalName: ModalEnum,
    rowData: SessionDTOExtended | Vehicle
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;

/* istanbul ignore next */
function mapDispatchToProps(dispatch: any) {
    return bindActionCreators({
        openModal: modalWindowActions.updateModalWindow,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(EditableTableField);